import Modal from '../Modal';

const PreviewModal = ({open, onClose, file}) => (
  <Modal open={open} onClose={onClose}>
    <img src={file} alt="Preview File" />
  </Modal>
);

export default PreviewModal;
